var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUsersPairFilled = function SvgUsersPairFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9M14 24H1a1 1 0 0 1-1-1v-.5a7.5 7.5 0 1 1 15 0v.5a1 1 0 0 1-1 1m3.5-15a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9m-1.421 2.021a6.83 6.83 0 0 0-4.67 2.831A9.54 9.54 0 0 1 16.323 19H23a1 1 0 0 0 1-1v-.038a7.008 7.008 0 0 0-7.921-6.941"
  })));
};
export default SvgUsersPairFilled;